<template>
  <div class="w-full grid grid-cols-12 font-rubik">
    <app-header />
    <div
        class="col-span-12 sm:col-start-2 sm:col-span-10 xl:col-start-3 xl:col-span-8 flex flex-col font-bold text-lg px-5 sm:px-0"
    >
      <h6 class="my-10 font-extrabold text-2xl">Лого ашиглах заавар</h6>
      <p class="text-base" style="color: #94A3B8;">
        М нэмэх ХХК-ны нэр болон лого нь компаниейг төлөөлөх хамгийн үнэ цэнтэй зүйлсийн нэг юм. Тиймээс хэн нэгэн ямар нэгэн байдлаар Mbook логог зохисгүй ашиглах нь брэндийн өмч болон хууль эрх зүйн үүднээс тодорхой эрсдэлд оруулахыг анхаарна уу. Иймд та логог ашиглахдаа дараах заавартай заавал танилцахыг зөвлөж байна. Асууж тодруулах зүйл гарвал contents@m-book.mn хаягаар илгээгээрэй.
      </p>
      <div class="flex flex-row items-center justify-between  mt-16">
        <div class="flex flex-row space-x-2">
          <icon-face />
          <p><span class="hidden xs:inline">БРЭНДИЙН</span> ЛОГО</p>
        </div>

        <a
            :href="publicPath + 'mbook-assets.zip'"
            class="flex flex-row items-center shadow-md rounded-full py-2 pl-7 pr-4  text-sm font-light border brand-border-dark"
            download
        >
          <p class="flex-grow pr-3">Бүгдийг татах</p>
          <icon-download />
        </a>
      </div>

      <div class="mt-5 flex flex-wrap">
        <asset-box pngName="mbook.png" svgName="mplus.svg" />
        <asset-box
            pngName="mbookwhite.png"
            svgName="mpluswhite.svg"
            color="#0061FF"
        />
        <asset-box
            pngName="mzone.png"
            svgName="mzone.svg"
        />
        <asset-box
            pngName="mzonewhite.png"
            svgName="mzonewhite.svg"
            color="#0061FF"
        />
      </div>

      <div class="flex flex-col font-bold">
        <div class="flex flex-row items-center space-x-2 mt-10 mb-3">
          <icon-droplet />
          <p>АРЫН ДЭВСГЭР ӨНГӨ</p>
        </div>
        <p class="text-sm font-normal mb-6 text-gray-400">Хэвлэмэл болон дижитал орчинд ашиглана.</p>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">

          <div>
            <p class="text-xs font-bold text-gray-400 tracking-wider mb-3">Дижитал орчинд ашиглах өнгө</p>
            <div class="flex flex-col space-y-3 w-full">
              <img :src="publicPath + 'logos/Mbook-blue.png'" alt="Mbook Blue" class="w-full aspect-[21/9] border border-blue-50 rounded-2xl object-cover cursor-pointer hover:opacity-90 transition" @click="openModal('logos/Mbook-blue.png')" />
              <img :src="publicPath + 'logos/Mbook-blackbg.png'" alt="Mbook Black BG" class="w-full aspect-[21/9] border border-blue-50 rounded-2xl object-cover cursor-pointer hover:opacity-90 transition" @click="openModal('logos/Mbook-blackbg.png')" />
              <img :src="publicPath + 'logos/Mbook-white.png'" alt="Mbook White" class="w-full aspect-[21/9] border border-blue-50 rounded-2xl object-cover cursor-pointer hover:opacity-90 transition" @click="openModal('logos/Mbook-white.png')" />
            </div>
          </div>

          <div>
            <p class="text-xs font-bold text-gray-400 tracking-wider mb-3">Хэвлэмэл хувилбарт ашиглах өнгө</p>
            <div class="flex flex-col space-y-3 w-full">
              <img :src="publicPath + 'logos/Mbook-bluesmuk.png'" alt="Mbook Blue CMYK" class="w-full aspect-[21/9] border border-blue-50 rounded-2xl object-cover cursor-pointer hover:opacity-90 transition" @click="openModal('logos/Mbook-bluesmuk.png')" />
              <img :src="publicPath + 'logos/Mbook-blacksmuk.png'" alt="Mbook Black CMYK" class="w-full aspect-[21/9] border border-blue-50 rounded-2xl object-cover cursor-pointer hover:opacity-90 transition" @click="openModal('logos/Mbook-blacksmuk.png')" />
              <img :src="publicPath + 'logos/Mbook-whitesmuk.png'" alt="Mbook White CMYK" class="w-full aspect-[21/9] border border-blue-50 rounded-2xl object-cover cursor-pointer hover:opacity-90 transition" @click="openModal('logos/Mbook-whitesmuk.png')" />
            </div>
          </div>

        </div>
      </div>

      <div class="flex flex-row items-center space-x-2 mt-16">
        <icon-droplet />
        <p>ӨНГӨНИЙ КОД (БРЭНДИНГ)</p>
      </div>

      <div class="mt-5 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4 w-full">
        <div class="aspect-square border border-blue-50 rounded-2xl overflow-hidden shadow-sm bg-gray-50">
          <img :src="publicPath + 'logos/1.png'" alt="Color 1" class="w-full h-full object-cover cursor-pointer hover:scale-105 transition duration-200" @click="handleColorClick('logos/1.png', '#0061FF')" />
        </div>
        <div class="aspect-square border border-blue-50 rounded-2xl overflow-hidden shadow-sm bg-gray-50">
          <img :src="publicPath + 'logos/2.png'" alt="Color 2" class="w-full h-full object-cover cursor-pointer hover:scale-105 transition duration-200" @click="handleColorClick('logos/2.png', '#0747CC')" />
        </div>
        <div class="aspect-square border border-blue-50 rounded-2xl overflow-hidden shadow-sm bg-gray-50">
          <img :src="publicPath + 'logos/3.png'" alt="Color 3" class="w-full h-full object-cover cursor-pointer hover:scale-105 transition duration-200" @click="handleColorClick('logos/3.png', '#192434')" />
        </div>
        <div class="aspect-square border border-blue-50 rounded-2xl overflow-hidden shadow-sm bg-gray-50">
          <img :src="publicPath + 'logos/3_1.png'" alt="Color 3_1" class="w-full h-full object-cover cursor-pointer hover:scale-105 transition duration-200" @click="handleColorClick('logos/3_1.png', '#000000')" />
        </div>
        <div class="aspect-square border border-blue-50 rounded-2xl overflow-hidden shadow-sm bg-gray-50">
          <img :src="publicPath + 'logos/4.png'" alt="Color 4" class="w-full h-full object-cover cursor-pointer hover:scale-105 transition duration-200" @click="handleColorClick('logos/4.png', '#CED9EA')" />
        </div>
        <div class="aspect-square border border-blue-50 rounded-2xl overflow-hidden shadow-sm bg-gray-50">
          <img :src="publicPath + 'logos/6.png'" alt="Color 6" class="w-full h-full object-cover cursor-pointer hover:scale-105 transition duration-200" @click="handleColorClick('logos/6.png', '#FFFFFF')" />
        </div>
      </div>
      <div class="h-20"></div>
    </div>

    <div
        v-if="isModalOpen"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm p-4 cursor-zoom-out"
        @click="closeModal"
    >
      <div class="relative max-w-4xl max-h-[85vh] flex items-center justify-center bg-white p-2 rounded-2xl shadow-2xl" @click.stop>
        <button
            @click="closeModal"
            class="absolute -top-12 right-0 text-white hover:text-gray-300 flex items-center space-x-1 font-normal text-sm bg-black bg-opacity-40 py-1.5 px-3 rounded-full transition"
        >
          <span>Хаах</span>
          <span class="text-xs">✕</span>
        </button>
        <img :src="publicPath + selectedImage" class="max-w-full max-h-[80vh] rounded-xl object-contain shadow-lg" alt="Zoomed Logo" />
      </div>
    </div>

    <div
        v-if="showToast"
        class="fixed bottom-5 right-5 z-50 bg-gray-900 text-white px-5 py-3 rounded-xl shadow-lg text-sm font-normal flex items-center space-x-2 transition duration-300 animate-bounce"
    >
      <span class="text-green-400">✓</span>
      <span>Өнгөний код <b>{{ copiedColor }}</b> санах ойд хуулагдлаа!</span>
    </div>

  </div>
</template>

<script>
import AssetBox from "./components/AssetBox.vue";
import IconDroplet from "./assets/components/IconDroplet";
import IconFace from "./assets/components/IconFace";
import AppHeader from "./components/AppHeader";
import IconDownload from "./assets/components/IconDownload";

export default {
  name: "App",
  components: {
    AssetBox,
    IconDroplet,
    IconFace,
    AppHeader,
    IconDownload,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      isModalOpen: false,
      selectedImage: '',
      // Мэдэгдэл удирдах шинэ дата
      showToast: false,
      copiedColor: '',
    };
  },
  meta: { title: "Mplus Assets" },
  methods: {
    openModal(imagePath) {
      this.selectedImage = imagePath;
      this.isModalOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.isModalOpen = false;
      this.selectedImage = '';
      document.body.style.overflow = '';
    },
    // Өнгөн дээр дарахад ЗЭРЭГ ажиллах шинэ функц
    handleColorClick(imagePath, colorHex) {
      // 1. Зургийг томруулж харуулах
      this.openModal(imagePath);

      // 2. Өнгөний кодыг copy хийх
      navigator.clipboard.writeText(colorHex).then(() => {
        this.copiedColor = colorHex;
        this.showToast = true;

        // 2.5 секундын дараа мэдэгдлийг нуух
        setTimeout(() => {
          this.showToast = false;
        }, 2500);
      }).catch(err => {
        console.error('Код хуулж чадсангүй: ', err);
      });
    }
  }
};
</script>

<style>
body {
  margin: 0;
  background-color: #ffffff;
}
</style>